<script setup>
import ItemSelectCustomer from '@/Components/ItemSelectCustomer.vue';
import TextField from '@/Components/TextField.vue';

defineProps({
    params: {
        type: Array,
        required: true,
    },
    errors: {
        type: [Object, null],
        required: true,
    },
});

const queryParams = defineModel({
    type: Object,
    required: true,
});
</script>

<template>
    <div v-if="params.length > 0">
        <template v-for="param in params" :key="param">
            <ItemSelectCustomer
                v-if="param === 'item_number'"
                v-model="queryParams.item_number"
                label="Artikel"
                :error-messages="errors?.item_number"
            ></ItemSelectCustomer>
            <!--            date field -->
            <TextField
                v-else-if="param === 'date'"
                v-model="queryParams.date"
                label="Datum"
                type="date"
                :error-messages="errors?.date"
            ></TextField>
        </template>
    </div>
</template>

<style scoped></style>
